import TestimonialsGridBlock1 from '../common/blocks/TestimonialsGridBlock1';
const Staff = () => {
	return (
		<TestimonialsGridBlock1/>	
	);
};
export default Staff;